import React from 'react';

import { useSearchSuggestionsHeight } from './useSearchSuggestionsContainerHeight';
import * as styles from './SearchSuggestionsContainer.styles';
import { useSearchContext } from 'client-site-chrome-ui/context/SearchContext/useSearchContext';

export const SearchSuggestionsContainer = () => {
  const {
    search: { isSuggestionsShown, suggestions },
    searchSuggestionsRef: { current },
  } = useSearchContext();

  const height = useSearchSuggestionsHeight(current, suggestions);

  return isSuggestionsShown ? (
    <div
      css={styles.searchSuggestionsContainer}
      data-testid="search-suggestions-container"
      style={
        {
          '--suggestionsHeight': `${height}px`,
        } as styles.SearchSuggestionsCSSProperties
      }
    />
  ) : null;
};
